var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6115 1.39844C18.7254 1.39844 19.7937 1.86697 20.5814 2.70095C21.369 3.53494 21.8115 4.66606 21.8115 5.8455H26.0115C26.7541 5.8455 27.4663 6.15785 27.9914 6.71384C28.5165 7.26983 28.8115 8.02391 28.8115 8.8102V23.6337C28.8115 24.42 28.5165 25.1741 27.9914 25.7301C27.4663 26.2861 26.7541 26.5984 26.0115 26.5984H3.61152C2.86892 26.5984 2.15673 26.2861 1.63162 25.7301C1.10652 25.1741 0.811523 24.42 0.811523 23.6337V8.8102C0.811523 8.02391 1.10652 7.26983 1.63162 6.71384C2.15673 6.15785 2.86892 5.8455 3.61152 5.8455H7.81152C7.81152 4.66606 8.25402 3.53494 9.04168 2.70095C9.82933 1.86697 10.8976 1.39844 12.0115 1.39844H17.6115ZM19.0115 8.8102H10.6115V23.6337H19.0115V8.8102ZM26.0115 8.8102H21.8115V23.6337H26.0115V8.8102ZM7.81152 8.8102H3.61152V23.6337H7.81152V8.8102ZM17.6115 4.36314H12.0115C11.6686 4.36319 11.3377 4.49649 11.0814 4.73776C10.8252 4.97902 10.6614 5.31148 10.6213 5.67206L10.6115 5.8455H19.0115C19.0115 5.48242 18.8856 5.13199 18.6577 4.86066C18.4299 4.58934 18.1159 4.416 17.7753 4.37352L17.6115 4.36314Z",
    fill: "#58486C",
    stroke: "white",
    strokeWidth: 1.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.ab1f386418c08fe737942248bcb23877.svg";
export { ForwardRef as ReactComponent };